/* eslint-disable import/no-webpack-loader-syntax */
import 'script-loader!jquery/dist/jquery.min.js'
import 'script-loader!underscore/underscore-min.js'
import 'script-loader!backbone/backbone-min.js'
import 'script-loader!bootstrap/dist/js/bootstrap.bundle.min.js'
import 'script-loader!@splidejs/splide/dist/js/splide.min.js'
import 'script-loader!./vendor/jquery-rebox.js'
import 'script-loader!./vendor/jquery-scroll.js'
import 'script-loader!./vendor/googleMaps.js'